export default "__VITE_ASSET__BDQOc08B__"